export default __webpack_public_path__ + "static/4-808cd60f3abca8dcda6e64bc8211969e.png";